import { render } from "./AssignmentsModule.vue?vue&type=template&id=94c86920&scoped=true"
import script from "./AssignmentsModule.vue?vue&type=script&lang=js"
export * from "./AssignmentsModule.vue?vue&type=script&lang=js"

import "./AssignmentsModule.vue?vue&type=style&index=0&id=94c86920&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94c86920"

export default script